import { Button, CircularProgress, Theme } from '@mui/material';
import { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';

type Props = {
  posting: boolean;
  theme: Theme;
  saveLabel?: string;
  disableSave?: boolean;
  onCancel: () => void;
  onSave: () => void;
};

export function PartnerModalFooterActions({
  posting,
  theme,
  saveLabel,
  disableSave,
  onCancel,
  onSave,
}: Props) {
  const { translatedText } = useContext(LocaleContext);

  return (
    <>
      <Button variant='secondary' size='large' onClick={onCancel}>
        {translatedText.common.buttonCancel}
      </Button>

      <Button variant='primary' size='large' onClick={onSave} disabled={posting || disableSave}>
        {posting ? (
          <>
            <span>{translatedText.common.statusUpdating} </span>
            <CircularProgress
              style={{ color: theme.palette.grey[500], marginLeft: '5px' }}
              size='16px'
            />
          </>
        ) : (
          (saveLabel ?? translatedText.common.buttonUpdate)
        )}
      </Button>
    </>
  );
}
